module.exports = __webpack_public_path__ + "img/project-management.fe18a1d3.svg";